import React, { useState } from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import About from './About';
import Works from './Works';
import Contributions from './Contributions';
import Contact from './Contact';
import './Portfolio.css';
import ScrollReveal from './utils/ScrollReveal';

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState('home');

  React.useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'works', 'contributions', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
        const rect = element.getBoundingClientRect();

        // Detecta se a seção ocupa pelo menos 40% da tela
        const inView = rect.top <= window.innerHeight * 0.4 &&
                       rect.bottom >= window.innerHeight * 0.4;

        if (inView) {
          setActiveSection(section);
          break;
        }

          /*const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }*/
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="portfolio">
      <Navigation activeSection={activeSection}/>
      <main>
        <ScrollReveal> <Hero /> </ScrollReveal>
        <ScrollReveal> <Works /> </ScrollReveal>
        <ScrollReveal> <Contributions /> </ScrollReveal>
        <ScrollReveal> <Contact /> </ScrollReveal>
      </main>
    </div>
  );
};

export default Portfolio;